import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TPreparedVitrinsOffer, TVitrinsOffer } from 'shared/types/TVitrinsService';

import { vitrinsQueries } from 'entities/vitrins/model/vitrins.query';

/**
 * TODO: Доработать в рамках https://sravni-corp.atlassian.net/browse/CF-3559
 * Доработать типизацию сущности vitrins
 */

interface IInitialState {
  offers: TVitrinsOffer[];
  preparedOffers: TPreparedVitrinsOffer[];
}

const initialState: IInitialState = {
  preparedOffers: [],
  offers: [],
};

export const vitrinsSlice = createSlice({
  name: 'vitrinsOffers',
  initialState,
  reducers: {
    setVitrinsOffers: (state, { payload }: PayloadAction<IInitialState>) => {
      state.offers = payload.offers;
      state.preparedOffers = payload.preparedOffers;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(vitrinsQueries.endpoints.getVitrins.matchFulfilled, (state, { payload }) => {
      state.offers = payload.offers;
      state.preparedOffers = payload.preparedOffers;
    });
  },
});

export const { setVitrinsOffers } = vitrinsSlice.actions;
